module.exports = __webpack_public_path__ + "static/media/mommy.194397ac.svg";